export { Easing, EasingValues } from './easing/index.js';
